import { render, staticRenderFns } from "./InvestorOnboardingOccupation.vue?vue&type=template&id=611fa598&"
import script from "./InvestorOnboardingOccupation.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingOccupation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports